module.exports = __webpack_public_path__ + "img/screen-manual-4.e8bdb280.png";